import {create} from 'zustand';
import {devtools} from 'zustand/middleware';
import {getCookie} from '@/utils/main';

const store = (set) => ({
  isDarkMode: false,
  isDialogOpened: false,
  isLnbOpened: getCookie('soop-navigation-ui-config') !== 'mini',
  autoTagStyle: [], //이벤트 태그의 스타일
  refreshTimestamp: null, // 동일한 패스로 라우팅 될때 발동
  setIsDarkMode: (item) => {
    return set((state) => {
      return {
        isDarkMode: item,
      };
    });
  },
  setIsLnbOpened: (isOpen) => {
    return set((state) => {
      // gobalNavigaiton.handleThemeChanged 콜백으로 부터 전달
      return {
        isLnbOpened: isOpen,
      };
    });
  },
  setDialogOpened: (opened) => {
    return set((state) => {
      return {
        isDialogOpened: opened,
      };
    });
  },

  setAutoTagStyle: (item) => {
    set((state) => {
      return {autoTagStyle: [...item]};
    });
  },
  setRefreshTimestamp: () => {
    return set((state) => {
      return {
        refreshTimestamp: new Date().getTime(),
      };
    });
  },
});

const useGlobalUIStore = create(devtools(store));

export default useGlobalUIStore;
